import { orDefault } from '@/common/utils';

const configMixin = {
  methods: {
    getModuleConfig(moduleType, moduleInstance) {
      let moduleTypeAndInstance = moduleType + (moduleInstance ? `_${moduleInstance}` : '');
      let module = this.$store.state.configs.moduleConfigsByModuleTypeAndInstance[moduleTypeAndInstance];

      return module;
    },
    isFavoritesEnabled(moduleType, moduleInstance) {
      let moduleConfig = this.getModuleConfig(moduleType, moduleInstance);
      if (moduleConfig) {
        return moduleConfig.favoritesEnabled;
      }
    },
    mx_isUnreadCountFeatureEnabled(moduleType, moduleInstance) {
      let moduleConfig = this.getModuleConfig(moduleType, moduleInstance);
      if (moduleConfig) {
        // console.debug(`isUnreadCountFeatureEnabled ${moduleType} ${moduleInstance} hasBadge=${moduleConfig.hasBadge}`);
        return moduleConfig.hasBadge;
      }
    },
  },
  computed: {
    modules() {
      return this.$store.state.configs.modules;
    },
    features() {
      return this.$store.state.configs.features;
    },
    configuredTimeFormat() {
      let userProfile = this.$store.state.profile.userProfile;
      if (userProfile.timeFormat) return userProfile.timeFormat;
      return this.features.timeFormat || 'hh:mm';
    },
  },
};

export default configMixin;
